'use client'

import { motion } from 'motion/react'
import { cn } from '@/utils/styles/cn'

export interface SkeletonProps {
    className?: string
    borderRadius?: string
    style?: React.CSSProperties
    baseOpacity?: number
}

export const Skeleton = ({ className, style, baseOpacity = 0.45 }: SkeletonProps) => {
    return (
        <motion.div
            initial={{ opacity: baseOpacity }}
            animate={{
                opacity: [
                    Math.max(baseOpacity - 0.17, 0),
                    Math.max(baseOpacity, 0),
                    Math.max(baseOpacity - 0.17, 0),
                ],
            }}
            transition={{ repeat: Infinity, ease: 'linear', duration: 1 }}
            style={style}
            className={cn('rounded-[8px] w-full h-full bg-black/10', className)}
        />
    )
}
